import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=14073b7c"
import script from "./Topbar.vue?vue&type=script&lang=js"
export * from "./Topbar.vue?vue&type=script&lang=js"
import style0 from "./Topbar.vue?vue&type=style&index=0&id=14073b7c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14073b7c')) {
      api.createRecord('14073b7c', component.options)
    } else {
      api.reload('14073b7c', component.options)
    }
    module.hot.accept("./Topbar.vue?vue&type=template&id=14073b7c", function () {
      api.rerender('14073b7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/header/Topbar.vue"
export default component.exports